import React, { useState } from 'react';

import Button, { BUTTON_SIZES } from 'buyside/components/presentation/Button/button';
import {
  EmailShareButton,
  EmailIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon
} from 'react-share';

import { buysideSignUpUrl } from 'buyside/util/urlHelper';

import styles from './socialShareStyles.scss';

const SocialShare: React.FC<{ id: string }> = ({ id }): React.ReactElement => {
  const [isCopied, setIsCopied] = useState(false);
  const referralLink = 'https://www.sumzero.com' + buysideSignUpUrl(id);

  const copyReferralLinkToClipboard = async (): Promise<boolean | void> => {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(referralLink);
    } else {
      return document.execCommand('copy', true, referralLink);
    }
  };

  const handleCopyClick = (): void => {
    copyReferralLinkToClipboard().then(() => {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1500);
    });
  };

  return (
    <>
      <div
        className={styles.displayLink}
        onClick={handleCopyClick}
        title="Click to Copy to Clipboard"
      >
        {referralLink}
      </div>
      <div className={styles.shareLinkButtonContainer}>
        <Button
          size={BUTTON_SIZES.SMALL}
          text={isCopied ? 'Copied!' : 'Copy Link'}
          onClick={handleCopyClick}
        />
        <EmailShareButton
          subject="Invitation to join SumZero"
          body="Hello! SumZero hosts the leading global database of original, buyside investment research containing thousands of fully-developed write-ups on actionable long/short equity and credit ideas. Please feel free to use the following referral link to sign up today: "
          url={referralLink}
        >
          <EmailIcon size="42px" bgStyle={{ fill: '#dddddd' }} iconFillColor="333333" />
        </EmailShareButton>
        <LinkedinShareButton source="SumZero" url={referralLink}>
          <LinkedinIcon size="42px" />
        </LinkedinShareButton>
        <TwitterShareButton url={referralLink} title="Join SumZero!">
          <TwitterIcon size="42px" />
        </TwitterShareButton>
      </div>
    </>
  );
};

export default SocialShare;
